//时间格式化
/**
 *
 *
 * @export 时间格式化
 * @param {*} dateStr 时间戳或者时间字符串
 * @param {string} [fmt='yyyy-MM-dd hh:mm:ss']
 * @return {*}
 */
export function formatDate(dateStr, fmt = 'yyyy-MM-dd hh:mm:ss') {
  if (!dateStr) return;
  const date = new Date(dateStr);
  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  };

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, `${date.getFullYear()}`.substr(4 - RegExp.$1.length));
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length));
    }
  }
  return fmt;
}

/**
 *
 *
 * @export 获取当前时间并格式化
 * @param {*} isDate Boolean 为真返回时分秒； 为"time"返回不带连接符的时分秒；为"fileDate"返回文件夹日期
 * @return {*} yyyy-MM-dd hh:mm:ss
 */
export function getNowTime(isDate = false) {
  var now = new Date();
  var year = now.getFullYear(); //得到年份
  var month = now.getMonth(); //得到月份
  var date = now.getDate(); //得到日期
  var hh = now.getHours();
  var mm = now.getMinutes();
  var ss = now.getSeconds();
  hh = hh.toString().padStart(2, '0');
  mm = mm.toString().padStart(2, '0');
  ss = ss.toString().padStart(2, '0');
  var hour = ' ' + hh + ':' + mm + ':' + ss + ''; //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
  var hours = hh + '' + mm + '' + ss + '-';

  month = month + 1;
  month = month.toString().padStart(2, '0');
  date = date.toString().padStart(2, '0');

  // 当前日期的前30
  var currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - 30);
  var monYear = currentDate.getFullYear(); //得到年份
  var monMont = currentDate.getMonth() + 1; //得到月份
  var monDate = currentDate.getDate(); //得到日期

  var defaultDate = `${year}-${month}-${date}${hour}`;
  if (isDate) {
    defaultDate = `${year}-${month}-${date}`;
  }
  if (isDate == 'time') {
    // 返回给文件前添加的时间
    defaultDate = `${year}${month}${date}${hours}`;
  }
  if (isDate == 'fileDate') {
    // 返回默认创建文件夹的时间
    defaultDate = `${year}${month}${date}`;
  }
  if (isDate == 'realTime') {
    defaultDate = hour;
  }
  // 30天
  if (isDate == 'motTime') {
    var defaultDate = `${monYear}-${monMont}-${monDate} 00:00:00`;
  }
  return defaultDate;
}
/**
 * 日期补全
 * @returns
 */
export function getDateCompletion(tim1, tim2) {
  function getDaysInMonth(year, month) {
    return new Date(year, month, 0).getDate();
  }
  let obtain = getDaysInMonth(tim1, tim2);

  return `${tim1}-${tim2}-${obtain}`;
}
/**
 *  验证失败定位
 * @returns
 */
export function failCheckPosition() {
  setTimeout(() => {
    var isError = document.getElementsByClassName('is-error');
    isError[0].querySelector('input').focus();
  }, 100);
  return false;
}
/**
 * 获取星期
 * @returns
 */
export function getWeek() {
  let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
  let wk = new Date().getDay();
  return weeks[wk];
}

/**
 * @export 获取图片路径
 * @param {*} 参数1
 * @param {*} 参数2
 * @description
 * @author
 * @version V1.0.0
 * @return {*}
 */
//
export function getImgName(url, num = 3) {
  if (url) {
    let index1 = findCharIndex(url, '/', num);
    // console.log("index1", index1);
    let index2 = url.lastIndexOf('?');
    // console.log("index2", index2);
    url = url.substring(0, index1 + 1);
    // index2 != -1 ?
    // url.substring(index1 + 1, index2) :
    // url.substring(index1 + 1, url.length);
    return url;
  }
}

/**
 * @export 获取某个字符在一串字符中第n次出现的位置（注意：从0开始计数）
 * @param {*} 参数1
 * @param {*} 参数2
 * @description
 * @author
 * @version V1.0.0
 * @return {*}
 */
//

function findCharIndex(str, cha, num) {
  let x = str.indexOf(cha);
  for (let i = 0; i < num; i++) {
    x = str.indexOf(cha, x + 1);
  }
  return x;
}

export function disabledBtn(el) {
  console.log(el.$el.disabled);
  el.$el.disabled = true;
  console.log(el.$el.disabled);
  setTimeout(() => {
    el.$el.disabled = false;
  }, 1000);
}

/**
 * @export 获取几天前的日期
 * @param {*} num
 * @description
 * @author
 * @version V1.0.0
 * @return {*}
 */
export function getDateEasy(p_count) {
  // 今天
  let today = new Date();
  let ty = today.getFullYear();
  let tm = today.getMonth() + 1; //获取当前月份的日期
  if (tm < 10) {
    tm = '0' + tm;
  }
  let td = today.getDate();
  if (td < 10) {
    td = '0' + td;
  }
  // 几天前
  let dd = new Date();
  dd.setDate(dd.getDate() + Number(p_count)); //获取p_count天后的日期
  let y = dd.getFullYear();
  let m = dd.getMonth() + 1; //获取当前月份的日期
  if (m < 10) {
    m = '0' + m;
  }
  let d = dd.getDate();
  if (d < 10) {
    d = '0' + d;
  }

  return {
    date_start: y + '-' + m + '-' + d + ' 00:00:00',
    date_end: ty + '-' + tm + '-' + td + ' 23:59:59',
  };
}
/**
 * @export 防抖
 * @param {*} fn 要防抖的函数
 * @param {*}
 * @description
 * @author
 * @version V1.0.0
 * @return {*}
 */
export function debounce(fn, delay = 300) {
  //默认300毫秒
  var timer;
  return function () {
    let args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(this, args); // this 指向vue
    }, delay);
  };
}

/**
 * @export 获取俩时间的时间差（x天x小时x分钟x秒）
 * @param {*} 参数1
 * @param {*} 参数2
 * @description
 * @author
 * @version V1.0.0
 * @return {*}
 */
// date2 大于 date1
export function getDiffDateTime(date1, date2, type = '') {
  // var date1= '2018-11-30 11:39:10';  //开始时间
  // var date2 = new Date();    //结束时间
  const date3 = new Date(date2).getTime() - new Date(date1).getTime(); //时间差的毫秒数
  //计算出相差天数
  const days = Math.floor(date3 / (24 * 3600 * 1000));
  //计算出小时数
  const leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
  const hours = Math.floor(leave1 / (3600 * 1000));
  //计算相差分钟数
  const leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
  const minutes = Math.floor(leave2 / (60 * 1000));
  //计算相差秒数
  const leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
  const seconds = Math.round(leave3 / 1000);
  let diffValue;
  // if (days > 0) {
  //   diffValue = days + "天 " + hours + "小时 " + minutes + " 分钟" + seconds + " 秒"
  // } else {
  //   diffValue = hours + "小时 " + minutes + " 分钟" + seconds + " 秒"
  // }
  if (type == 'day') {
    diffValue = days;
  }
  if (type == 'all') {
    diffValue = days + '天 ' + hours + '小时 ' + minutes + ' 分钟' + seconds + ' 秒';
  }
  if (type == '') {
    diffValue = {
      days: days,
      hours: hours,
      minutes: minutes,
    };
  }
  return diffValue;
}

/**
 * @export 为元素添加类名
 * @param {*} 参数1
 * @param {*} 参数2
 * @description
 * @author
 * @version V1.0.0
 * @return {*}
 */
// export function addClassForEl(el, className) {
//   let that = this;
//   let elArr = document.getElementsByClassName(el);
//   Array.prototype.forEach.call(elArr, function (item) {
//     if (that.isMobile) {
//       item.classList.add(className);
//     } else {
//       item.classList.remove(className);
//     }
//   });
// }

/**
 * @export 深拷贝
 * @param {*}
 * @param {*} 参数2
 * @description
 * @author
 * @version V1.0.0
 * @return {*}
 */
export function deepClone(source) {
  // 准备一个容器，先判断要拷贝的是哪种引用类型----数组、对象
  const targetObj = source.constructor === Array ? [] : {};
  for (let keys in source) {
    if (source.hasOwnProperty(keys)) {
      // 如果source中有这个keys属性
      // keys有三中情况：基本数据类型、对象、数组
      if (source[keys] && typeof source[keys] === 'object') {
        // 对象或者数组
        targetObj[keys] = source[keys].constructor === Array ? [] : {};
        // 递归
        targetObj[keys] = deepClone(source[keys]);
      } else {
        // 基本数据类型 直接赋值
        targetObj[keys] = source[keys];
      }
    }
  }
  // 返回处理后的
  return targetObj;
}
